import { createAsyncThunk } from "@reduxjs/toolkit";

import { fetchUserSubscriptions } from "../../../common/api";

export const loadUserSubscriptions = createAsyncThunk(
  "load-user-subscriptions",
  async () => {
    return fetchUserSubscriptions();
  },
);
